import { render, staticRenderFns } from "./shipTemplatePage.vue?vue&type=template&id=ef72bc58&scoped=true"
import script from "./shipTemplatePage.vue?vue&type=script&lang=js"
export * from "./shipTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./shipTemplatePage.vue?vue&type=style&index=0&id=ef72bc58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef72bc58",
  null
  
)

export default component.exports